// Main application JavaScript file
import '@css/app.css'
import '@css/menu.css'
import '@css/hamburger.css'

// Import Google Fonts locally
import '@css/fonts.css'

// Import JavaScript modules
import './menu.js'

// Conditional Plyr loader - only loads when video elements are present
import './plyr-loader.js'

console.log('Saline Agri Map application loaded')
